module.exports = __webpack_public_path__ + "static/weronikawork2-c720a1fe87339771588f6edc27c09793.jpg";